/* Hoptimaal: DPD-pakketpunt kiezen in de winkelwagen (snippets/hop-pakketpunt-wagen.liquid).
   Gedelegeerd op document, zodat het blijft werken als het thema de quick-cart opnieuw rendert.
   Opslaan als cart-attributen: "DPD Pickup Office" (WSA-formaat, source hoptimaal_winkelwagen)
   + "Pakketpunt" (leesbaar). Bron: vat33/shopify-theme/hoptimaal/assets/hop-pakketpunt-wagen.js */
(function () {
  var ATTR = 'DPD Pickup Office', LEESBAAR = 'Pakketpunt';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var gevonden = {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function afstand(km) { return km < 1 ? Math.round(km * 1000) + ' m' : km.toFixed(1).replace('.', ',') + ' km'; }
  // Quick-cart en /cart hebben elk een kopie van het blok: alle kopieën bijwerken.
  function toon(leesbaar, naam) {
    document.querySelectorAll('[data-hpw]').forEach(function (b) {
      var g = b.querySelector('[data-hpw-gekozen]');
      g.textContent = leesbaar; g.hidden = !leesbaar;
      b.querySelector('[data-hpw-kop]').textContent = leesbaar ? b.dataset.tGekozen + ': ' + naam : b.dataset.tKop;
      var k = b.querySelector('[data-hpw-kort]');
      if (k) k.textContent = b.dataset.tKort + (leesbaar ? ' ✓' : '');
      b.querySelector('[data-hpw-wis]').hidden = !leesbaar;
      if (!leesbaar) status(b, '');
    });
  }
  function status(box, tekst) { box.querySelector('[data-hpw-status]').textContent = tekst || ''; }

  function bewaar(box, attributen, klaar) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ attributes: attributen })
    }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); }).then(function () { klaar(); })
      .catch(function () { status(box, box.dataset.tFout); });
  }

  // Geen eigen <form>: het blok staat binnen het winkelwagenformulier van het thema.
  function zoek(box) {
    var lijst = box.querySelector('[data-hpw-lijst]');
    var pcVeld = box.querySelector('[data-hpw-postcode]');
    var pc = pcVeld.value.trim(), stad = box.querySelector('[data-hpw-stad]').value.trim();
    if (pc.length < 3) { pcVeld.focus(); return; }
    status(box, '…');
    var u = box.dataset.endpoint + '?land=' + encodeURIComponent(box.dataset.land) + '&postcode=' + encodeURIComponent(pc) + '&stad=' + encodeURIComponent(stad);
    fetch(u).then(function (r) { return r.json(); }).then(function (d) {
      if (!d.ok) { status(box, d.bericht || box.dataset.tFout); lijst.innerHTML = ''; return; }
      if (!d.punten.length) { status(box, box.dataset.tLeeg); lijst.innerHTML = ''; return; }
      status(box, '');
      lijst.innerHTML = d.punten.map(function (p) {
        gevonden[p.id] = p;
        return '<li class="hpw__punt"><div><div class="hpw__naam">' + esc(p.naam) + '</div><div class="hpw__adres">' + esc(p.straat) + ', ' + esc(p.postcode) + ' ' + esc(p.stad) + ' · ' + afstand(p.afstand) + '</div></div>' +
          '<button type="button" class="hpw__kies" data-hpw-kies="' + esc(p.id) + '">' + esc(box.dataset.tKies) + '</button></li>';
      }).join('');
    }).catch(function () { status(box, box.dataset.tFout); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest || !e.target.closest('[data-hpw-zoek]')) return;
    e.preventDefault(); // anders verstuurt Enter het winkelwagenformulier (= naar de checkout)
    zoek(e.target.closest('[data-hpw]'));
  });

  document.addEventListener('click', function (e) {
    var zk = e.target.closest && e.target.closest('[data-hpw-zoekknop]');
    if (zk) { e.preventDefault(); zoek(zk.closest('[data-hpw]')); return; }
    var kies = e.target.closest && e.target.closest('[data-hpw-kies]');
    var wis = e.target.closest && e.target.closest('[data-hpw-wis]');
    if (!kies && !wis) return;
    var box = (kies || wis).closest('[data-hpw]');
    var a = {};
    if (kies) {
      var p = gevonden[kies.dataset.hpwKies];
      if (!p) return;
      kies.disabled = true;
      a[ATTR] = JSON.stringify({
        office: p.naam, id: String(p.id),
        data: { x_pickupLocation: { address: { street: p.straat, town: p.stad, postcode: p.postcode, countryCode: p.land }, addressPoint: { latitude: String(p.lat), longitude: String(p.lng) } } },
        source: 'hoptimaal_winkelwagen'
      });
      a[LEESBAAR] = p.naam + ', ' + p.straat + ', ' + p.postcode + ' ' + p.stad;
      bewaar(box, a, function () {
        toon(a[LEESBAAR], p.naam);
        box.querySelector('[data-hpw-lijst]').innerHTML = '';
        status(box, box.dataset.tKlaar);
      });
    } else {
      a[ATTR] = ''; a[LEESBAAR] = '';
      bewaar(box, a, function () { toon('', ''); });
    }
  });
  // Compacte quick-cart (.hop-qc-extra): steeds maar één blok tegelijk open.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.open || !d.closest) return;
    var rij = d.closest('.hop-qc-extra');
    if (!rij) return;
    rij.querySelectorAll('details[open]').forEach(function (x) { if (x !== d) x.open = false; });
    var notitie = rij.querySelector('.quick-cart__footer-order-note-wrapper');
    if (notitie && notitie.querySelector('.icon-plus-small.hidden')) {
      var knop = notitie.querySelector('[data-order-note-trigger]');
      if (knop) {
        knop.click(); // notitie dicht via het thema zelf…
        // …maar het thema sluit open <details> bij een klik "erbuiten", dus dit blok weer openzetten
        setTimeout(function () { if (!d.open) d.open = true; }, 0);
      }
    }
  }, true);
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('.hop-qc-extra [data-order-note-trigger]');
    if (!knop || !e.isTrusted) return; // alleen een echte klik; onze eigen knop.click() hierboven niet
    knop.closest('.hop-qc-extra').querySelectorAll('details[open]').forEach(function (x) { x.open = false; });
  });
})();
